import React, { memo, useEffect, useState } from 'react';

// components
// import LetterPopover from './LetterPopover';
// import TextChangeHandler from './TextChangeHandler';

///// ref={textNodeRef} - it has listener for mouseDown to start highlighting text, show popover and so on...
const TemplateCreateLetterContent = ({ currentModeContent }) => {
	const [ currentContent, setCurrentContent ] = useState(null);

	useEffect(() => {
		if (currentModeContent) setCurrentContent(currentModeContent.content);
	}, [ currentModeContent ]);

	return (
        
		<>
			{currentContent && (
				<article
					className='letter__text--text'
					style={ { position: 'relative' } }
				>

					<div
						dangerouslySetInnerHTML={ { __html: currentContent.content } }
					/>

					{currentContent && currentContent.footnotes.length > 0 && (
						<div className='letter__text--footnotes'>
							{currentContent.footnotes.map((el, index) => (
								<div
									key={ index }
									dangerouslySetInnerHTML={ { __html: el } }
								/>
							))}
						</div>
					)}
				</article>
			)}
		</>
	);
};

export default memo(TemplateCreateLetterContent);